export const idx_data_span_measurement_64 = [];

let order = 0;
idx_data_span_measurement_64.push({
  fraction: '---',
  decimal: 0,
  order_idx: -1,
});

for (let i = 1; i < 7; i++) {
  if (i >= 2) {
    idx_data_span_measurement_64.push({
      fraction: i + '',
      decimal: i,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 1/64',
      decimal: i + 1 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 1/32',
      decimal: i + 1 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 3/64',
      decimal: i + 3 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 1/16',
      decimal: i + 1 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 5/64',
      decimal: i + 5 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 3/32',
      decimal: i + 3 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 7/64',
      decimal: i + 7 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 1/8',
      decimal: i + 1 / 8,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 9/64',
      decimal: i + 9 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 5/32',
      decimal: i + 5 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 11/64',
      decimal: i + 11 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 3/16',
      decimal: i + 3 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 13/64',
      decimal: i + 13 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 7/32',
      decimal: i + 7 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 15/64',
      decimal: i + 15 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 1/4',
      decimal: i + 1 / 4,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 17/64',
      decimal: i + 17 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 9/32',
      decimal: i + 9 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 19/64',
      decimal: i + 19 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 5/16',
      decimal: i + 5 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 21/64',
      decimal: i + 21 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 11/32',
      decimal: i + 11 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 23/64',
      decimal: i + 23 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 3/8',
      decimal: i + 3 / 8,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 25/64',
      decimal: i + 25 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 13/32',
      decimal: i + 13 / 32,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 27/64',
      decimal: i + 27 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 7/16',
      decimal: i + 7 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 29/64',
      decimal: i + 29 / 64,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement_64.push({
      fraction: i + ' 15/32',
      decimal: i + 15 / 32,
      order_idx: order,
    });
    order++;
  }

  idx_data_span_measurement_64.push({
    fraction: i + ' 31/64',
    decimal: i + 31 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 1/2',
    decimal: i + 1 / 2,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 33/64',
    decimal: i + 33 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 17/32',
    decimal: i + 17 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 35/64',
    decimal: i + 35 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 9/16',
    decimal: i + 9 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 37/64',
    decimal: i + 37 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 19/32',
    decimal: i + 19 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 39/64',
    decimal: i + 39 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 5/8',
    decimal: i + 5 / 8,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 41/64',
    decimal: i + 41 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 21/32',
    decimal: i + 21 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 43/64',
    decimal: i + 43 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 11/16',
    decimal: i + 11 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 45/64',
    decimal: i + 45 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 23/32',
    decimal: i + 23 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 47/64',
    decimal: i + 47 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 3/4',
    decimal: i + 3 / 4,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 49/64',
    decimal: i + 49 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 25/32',
    decimal: i + 25 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 51/64',
    decimal: i + 51 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 13/16',
    decimal: i + 13 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 53/64',
    decimal: i + 53 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 27/32',
    decimal: i + 27 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 55/64',
    decimal: i + 55 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 7/8',
    decimal: i + 7 / 8,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 57/64',
    decimal: i + 57 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 29/32',
    decimal: i + 29 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 59/64',
    decimal: i + 59 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 15/16',
    decimal: i + 15 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 61/64',
    decimal: i + 61 / 64,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 31/32',
    decimal: i + 31 / 32,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement_64.push({
    fraction: i + ' 63/64',
    decimal: i + 63 / 64,
    order_idx: order,
  });
  order++;
}

idx_data_span_measurement_64.push({
  fraction: '7',
  decimal: 7,
  order_idx: order,
});
